<div class="tabbar tab-style2" [ngClass]="{ 'navbar-pwa': pwaService.isInstalled() }">
  <ul class="flex flex-row align-items-center justify-content-center"
    [ngClass]="{ 'navbar-pwa': pwaService.isInstalled() }">
    <li *ngFor="let item of menu" [ngClass]="{ 'active': item.active, 'navbar-pwa': pwaService.isInstalled() }">
      <span class="material-icons-outlined" (click)="goTo(uid+item.path)">
        {{ item.icon }}
      </span>
    </li>
  </ul>
</div>